import { render } from "./Course.vue?vue&type=template&id=41479278&scoped=true&ts=true"
import script from "./Course.vue?vue&type=script&lang=ts"
export * from "./Course.vue?vue&type=script&lang=ts"

import "./Course.vue?vue&type=style&index=0&id=41479278&lang=css"
import "./Course.vue?vue&type=style&index=1&id=41479278&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41479278"]])

export default __exports__